import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EmailMessage } from "../../models/emails/email-message";
import { EmailService } from "../../services/email-service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-email-modal",
    templateUrl: "./email-modal.component.html",
    styleUrls: ["./email-modal.component.scss"],
    standalone: false
})
export class EmailModalComponent implements OnInit {
  documentId: string = null;
  constructor(
    @Optional() public dialogRef: MatDialogRef<EmailModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: EmailMessage,
    private emailService: EmailService,
    private route: ActivatedRoute,
  ) { }

  async ngOnInit() {
    this.documentId = this.route.snapshot.paramMap.get('documentId');
    if (this.documentId)
      this.data = await this.emailService.getEmailMessage(this.documentId).toPromise();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
